import { NgModule }            from '@angular/core';
import { CommonModule }        from '@angular/common';
import { registerLocaleData } from '@angular/common';
import { ToCurrencyStringPipe } from './currencyToString.pipe';
import { TranslatePipe } from '../translator/translator-pipe';
import {   FriendlyPaymentMethodName } from './friendlyPaymentMethodString.pipe';
import { RemoveSpecialCharsPipe } from './removeSpecialChar.pipe';
import { WebsiteTranslatePipe } from '../website/translation.pipe';
import { RegistryClassNamePipe } from '../website/registry-class.pipe';
import { TranslatePipeWeb } from '../translator/translator-pipe-web';
import { TranslateDatePipe } from '../shared/pipes/translate-date.pipe';
import { DateRangePipe } from '../shared/pipes/date-range.pipe';
import { FormatTextPipe } from './format-text.pipe';

// Import locales
import localeDa from '@angular/common/locales/da';
import localeNl from '@angular/common/locales/nl';
import localeEt from '@angular/common/locales/et';
import localeFi from '@angular/common/locales/fi';
import localeFr from '@angular/common/locales/fr';
import localeDe from '@angular/common/locales/de';
import localeEl from '@angular/common/locales/el';
import localeHu from '@angular/common/locales/hu';
import localeIt from '@angular/common/locales/it';
import localeLv from '@angular/common/locales/lv';
import localeLt from '@angular/common/locales/lt';
import localeNb from '@angular/common/locales/nb';
import localePl from '@angular/common/locales/pl';
import localePt from '@angular/common/locales/pt';
import localeSk from '@angular/common/locales/sk';
import localeSl from '@angular/common/locales/sl';
import localeEs from '@angular/common/locales/es';
import localeSv from '@angular/common/locales/sv';
import localeCs from '@angular/common/locales/cs';
import { HttpClientModule } from '@angular/common/http';

// Register all locale data
registerLocaleData(localeCs);  // Czech
registerLocaleData(localeDa);  // Danish
registerLocaleData(localeNl);  // Dutch
registerLocaleData(localeEt);  // Estonian
registerLocaleData(localeFi);  // Finnish
registerLocaleData(localeFr);  // French
registerLocaleData(localeDe);  // German
registerLocaleData(localeEl);  // Greek
registerLocaleData(localeHu);  // Hungarian
registerLocaleData(localeIt);  // Italian
registerLocaleData(localeLv);  // Latvian
registerLocaleData(localeLt);  // Lithuanian
registerLocaleData(localeNb);  // Norwegian
registerLocaleData(localePl);  // Polish
registerLocaleData(localePt);  // Portuguese
registerLocaleData(localeSk);  // Slovak
registerLocaleData(localeSl);  // Slovenian
registerLocaleData(localeEs);  // Spanish
registerLocaleData(localeSv);  // Swedish

@NgModule({
  imports:      [ CommonModule, HttpClientModule ],
  declarations: [ 
    ToCurrencyStringPipe, 
    TranslatePipe,
    TranslatePipeWeb, 
    FriendlyPaymentMethodName, 
    RemoveSpecialCharsPipe, 
    WebsiteTranslatePipe, 
    RegistryClassNamePipe,  
    TranslateDatePipe,
    DateRangePipe,
    FormatTextPipe 
  ],
  exports:      [ 
    ToCurrencyStringPipe, 
    TranslatePipe,
    TranslatePipeWeb, 
    FriendlyPaymentMethodName, 
    RemoveSpecialCharsPipe, 
    WebsiteTranslatePipe, 
    RegistryClassNamePipe, 
    TranslateDatePipe,
    DateRangePipe,
    FormatTextPipe 
  ],
  providers: [
    TranslateDatePipe,
    DateRangePipe  // Add this line to provide the pipe as a service
  ]
})
export class PipeModule { }



// WEBPACK FOOTER //
// ./src/app/pipes/pipe.moudle.ts